export default {
  namespaced: true,
  inventory: {
    title: "Inventario",
    new: "Nuevo inventario",
    edit: "Editar inventario",
    error_title: "Se encontraron errores en el archivo:",
    fields: {
      region: "Estado | Estados",
      municipality: "Municipio | Municipios",
      rems: "REMS",
      sirh: "SIRH",
      unit: "Inmueble",
      unit_name: "Nombre del inmueble",
      unit_type: "Tipo de inmueble",
      equipment_type: "Tipo de equipo",
      brand: "Marca",
      model: "Modelo",
      status: "Estatus",
      installation_date: "Fecha de Instalación",
      depreciation_start_date: "Fecha Inicio de Depreciación",
      useful_life_months: "Vida útil (meses)",
      remaining_life_months: "Vida restante (meses)",
      project: "Proyecto",
      project_id: "Proyecto ID",
      project_name: "Nombre de Proyecto",
      division: "División",
      municipality: "Municipio",
      unit_category: "Categoria de Inmueble",
      unit_name: "Nombre del inmueble",
      equipment_type: "Tipo de equipo",
      serial_number: "Número de Serie",
      fixed_asset_number: "Número de Activo Fijo",
      equipment_cost: "Costo equipo",
      accumulated_depreciation: "Depreciación acumulada",
      project: "Proyecto",

      name: "Nombre",
      updated_at: "Actualizado",
      created_at: "Creado",
    },
    actions: {
      cancel: "Cancelar",
      save: "Guardar",
    },
    status: {
      installed: "Instalado",
      new_custody: "Nuevo resguardo",
      paused: "En Pausa",
    },
    catalogs: {
      brands: "Catálogo de Marcas",
      projects: "Catálogo de Proyectos",
      equipmentTypes: "Catálogo de Tipos de Equipo",
    },
  },
};
